/**
 * Google Analytics utility functions
 * Uses gtag.js for Google Analytics 4 (GA4)
 */

// Initialize Google Analytics
export const initGA = (trackingId) => {
    if (!trackingId) {
        console.warn('Google Analytics tracking ID is not provided');
        return;
    }

    // Load gtag.js script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    document.head.appendChild(script1);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', trackingId, {
        page_path: window.location.pathname,
    });
};

// Track page views
export const trackPageView = (path) => {
    if (typeof window.gtag === 'function') {
        window.gtag('config', getTrackingId(), {
            page_path: path || window.location.pathname,
        });
    }
};

// Track events
export const trackEvent = (eventName, eventParams = {}) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, eventParams);
    }
};

// Get tracking ID from environment
export const getTrackingId = () => {
    try {
        // Try to get from env.json (for build-time config)
        const env = require('../env.json');
        if (env.GA_TRACKING_ID) {
            return env.GA_TRACKING_ID;
        }
    } catch (error) {
        // env.json might not exist, that's okay
    }
    // Fallback to environment variable (for runtime config)
    return process.env.REACT_APP_GA_TRACKING_ID;
};

// Common event tracking functions
export const analytics = {
    // User actions
    login: (method = 'email') => {
        trackEvent('login', { method });
    },
    
    signup: (method = 'email') => {
        trackEvent('sign_up', { method });
    },
    
    logout: () => {
        trackEvent('logout');
    },
    
    // Prompt interactions
    viewPrompt: (promptId, category) => {
        trackEvent('view_prompt', {
            prompt_id: promptId,
            category: category,
        });
    },
    
    likePrompt: (promptId) => {
        trackEvent('like_prompt', { prompt_id: promptId });
    },
    
    dislikePrompt: (promptId) => {
        trackEvent('dislike_prompt', { prompt_id: promptId });
    },
    
    favoritePrompt: (promptId, isFavorite) => {
        trackEvent(isFavorite ? 'add_to_favorites' : 'remove_from_favorites', {
            prompt_id: promptId,
        });
    },
    
    // Assessment
    startAssessment: () => {
        trackEvent('begin_assessment');
    },
    
    completeAssessment: () => {
        trackEvent('complete_assessment');
    },
    
    // Navigation
    clickButton: (buttonName, location) => {
        trackEvent('click_button', {
            button_name: buttonName,
            location: location,
        });
    },
    
    // Feedback
    submitFeedback: (rating) => {
        trackEvent('submit_feedback', { rating });
    },
    
    // Custom event
    custom: (eventName, params) => {
        trackEvent(eventName, params);
    },
};

